import React, { useEffect, useRef } from 'react';
import { Box, Text, Button, InfoModal, useInfoModalState } from '@mos-cat/ds';
import { pxToRem } from '@mos-cat/ds-theme';
import { STATS_EVENTS, sendStats } from '../../../helpers/sendStats';

export type Props = {
  onRetry: () => void;
  onClose?: () => void;
};

// typograf-enable
const RetryLaterModalBase = ({ onRetry, onClose }: Props) => {
  const infoModalState = useInfoModalState();
  const lastActiveElement = useRef<HTMLElement | null>(null);
  const isClosedByRetrying = useRef(false);
  const isAlreadyClosed = useRef(false);

  const modifiedInfoModalState = {
    ...infoModalState,
    show: () => {
      // Запоминаем последний активный элемент
      lastActiveElement.current = document.activeElement as HTMLElement;
      infoModalState.show();
    },
    hide: () => {
      infoModalState.hide();
      lastActiveElement.current?.focus();
    },
  };

  useEffect(() => {
    modifiedInfoModalState.show();
    sendStats(STATS_EVENTS.ERROR_MODAL, 'Просмотр');
  }, []);

  const handleRetry = () => {
    isClosedByRetrying.current = true;
    modifiedInfoModalState.hide();
    onRetry();
  };

  const handleClose = () => {
    if (isClosedByRetrying.current) {
      return;
    }
    const shouldCallCloseCb = !isAlreadyClosed.current && onClose;
    if (shouldCallCloseCb) {
      isAlreadyClosed.current = true;
      onClose();
    }
    modifiedInfoModalState.hide();
  };

  return (
    <InfoModal
      kind="error"
      heading="Не удалось загрузить список адресов"
      {...modifiedInfoModalState}
      hide={handleClose}
      styles={{ color: 'gray-90' }}
    >
      <Text>Попробуйте еще раз или повторите попытку позже.</Text>
      <Box mt="sp-24" display="flex" flexDirection={['column', 'row']}>
        <Button
          kind="primary"
          styles={{ flexGrow: [1, 0] }}
          onClick={handleRetry}
          data-cy="tech-error-modal-continue"
        >
          Повторить
        </Button>
        <Box p={[pxToRem(6), 'sp-8']} />
        <Button
          kind="tertiary"
          styles={{ flexGrow: [1, 0] }}
          onClick={handleClose}
          data-cy="tech-error-modal-close"
        >
          Закрыть
        </Button>
      </Box>
    </InfoModal>
  );
};

export default RetryLaterModalBase;
